<style>
</style>

<script lang="ts">
  import logo from '../resources/assets/logo.svg'
  import { locale } from 'svelte-i18n'
</script>

<div class="d-flex justify-content-center align-items-center h-100">
  <div class="text-center">
    {@html logo}
    {#if $locale == 'pt'}
      <p class="mt-5">
        <strong>O site da Fundação Ondjyla encontra-se em Manutenção.</strong>
      </p>
    {:else if $locale == 'es'}
      <p class="mt-5">
        <strong>El sitio web de la Fundación Ondjyla está en mantenimiento.</strong>
      </p>
    {:else if $locale == 'fr'}
      <p class="mt-5">
        <strong>Le site de la Fondation Ondjyla est en maintenance.</strong>
      </p>
    {:else}
      <p class="mt-5">
        <strong>The Ondjyla Foundation website is under Maintenance.</strong>
      </p>
    {/if}
  </div>
</div>
